import dayjs from "dayjs"
import { create } from "zustand"

interface RoutineStore {
  startDate: Date
  endDate: Date
  setStartDate: (startDate: Date) => void

  showParentCreatedRoutines: boolean
  setShowParentCreatedRoutines: (showParentCreatedRoutines: boolean) => void

  selectedUserId: string | number | null
  setSelectedUserId: (selectedUserId: string | number | null) => void
}

const getMondayOfCurrentWeek = () => {
  const today = new Date()
  const day = today.getDay()
  const diff = today.getDate() - day + (day === 0 ? -6 : 1) // adjust when day is Sunday
  return new Date(today.setDate(diff))
}

const useRoutinesStore = create<RoutineStore>((set) => ({
  startDate: getMondayOfCurrentWeek(),
  setStartDate: (startDate: Date) =>
    set({ startDate, endDate: dayjs(startDate).add(1, "week").toDate() }),
  endDate: dayjs(getMondayOfCurrentWeek()).add(1, "week").toDate(),

  showParentCreatedRoutines: false,
  setShowParentCreatedRoutines: (showParentCreatedRoutines: boolean) =>
    set({ showParentCreatedRoutines, selectedUserId: null }),

  selectedUserId: null,
  setSelectedUserId: (selectedUserId: string | number | null) =>
    set({ selectedUserId }),
}))

export default useRoutinesStore
